import { Component } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'ws-homepage',
  standalone: false,
  templateUrl: './ws-home.component.html',
  styleUrls: ['./ws-home.component.css'],
})
export class WaterSharingHomeComponent {
  constructor(private location: Location) { }

  goBack() {
    this.location.back();
  }
}
